import type { EmailCodeSent } from '@chukua/common';
import { api } from '../../../../shared/shared.api';

/** Sets a first password or replaces the one there is. */
export function setPassword(password: string): Promise<void> {
  return api<void>('/account/password', { method: 'PUT', body: JSON.stringify({ password }) });
}

/** Two-factor guards password sign-in only, so it turns off with the password. */
export function removePassword(): Promise<void> {
  return api<void>('/account/password', { method: 'DELETE' });
}

export interface TotpEnrollmentStart {
  secret: string;
  qrCodeDataUrl: string;
}

/** 409 without a password: there is no password sign-in for the app to guard. */
export function startTotpEnrollment(): Promise<TotpEnrollmentStart> {
  return api<TotpEnrollmentStart>('/auth/totp/enroll', { method: 'POST' });
}

/** `recoveryCodes` is empty when email codes already issued a set, which still stands. A wrong code answers 422. */
export function confirmTotpEnrollment(code: string): Promise<{ recoveryCodes: string[] }> {
  return api<{ recoveryCodes: string[] }>('/auth/totp/enroll/verify', { method: 'POST', body: JSON.stringify({ code }) });
}

export function disableTotp(): Promise<void> {
  return api<void>('/auth/totp/disable', { method: 'POST' });
}

/** Emails a code to the signed-in user's own address; email codes stay off until it comes back. A test deployment returns the code instead. */
export function startEmailOtp(): Promise<EmailCodeSent> {
  return api<EmailCodeSent>('/auth/email-otp/enable', { method: 'POST' });
}

/** `recoveryCodes` is empty when the authenticator app was already on: the saved set still stands. A wrong code answers 422. */
export function confirmEmailOtp(code: string): Promise<{ recoveryCodes: string[] }> {
  return api<{ recoveryCodes: string[] }>('/auth/email-otp/enable/verify', { method: 'POST', body: JSON.stringify({ code }) });
}

export function disableEmailOtp(): Promise<void> {
  return api<void>('/auth/email-otp/disable', { method: 'POST' });
}
